export const socialsData = {
    github: 'https://github.com/victorherrera95',
    
    linkedIn: 'https://www.linkedin.com/in/victor-alejandro-herrera-contreras/',
    
    
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    
}